import { useRef, useState } from "react";
import Image from "next/image";
import useOutsideClick from "@/hooks/useOutsideClick";
import {
  ISellerListingUploadVideo,
  UploadedVideoTypes,
} from "@/interfaces/listing/SellerListing";
import CustomVideo from "../ui/custom-video";

interface VideoListItemCustom extends ISellerListingUploadVideo {
  type: UploadedVideoTypes.Custom;
}

interface VideoListItemYoutube extends ISellerListingUploadVideo {
  type: UploadedVideoTypes.YouTube;
  safeUrl: string;
}

type VideoListItem = VideoListItemCustom | VideoListItemYoutube;

type VideoListModalProps = {
  isOpen: boolean;
  setIsOpen: Function;
  videos: VideoListItem[];
};

const VideoListModal: React.FC<VideoListModalProps> = ({
  isOpen,
  setIsOpen,
  videos,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflowY = "scroll";
  };

  useOutsideClick(modalRef, isOpen, setIsOpen);

  return (
    <div className="fixed top-0 left-0 w-full h-screen overflow-x-hidden overflow-y-scroll inset-0 outline-none focus:outline-none">
      <div
        className="relative w-full vs:w-5/6 lg:w-[1154px] mx-auto bg-white opacity-100"
        ref={modalRef}
      >
        <div className="fixed z-10 top-0 left-1/12 w-full vs:w-5/6 lg:w-[1154px] h-[70px] bg-white flex items-center px-8 hover:underline cursor-pointer">
          <div className="flex items-center" onClick={closeModal}>
            <span>
              <Image
                width={14}
                height={14}
                src="/assets/listings/arrow.png"
                alt="back"
              />
            </span>
            <span className="text-[#727a82] ml-3">Back to listing</span>
          </div>
        </div>
        <div className="mt-[70px]">
          {videos.map((video, index: number) => {
            return (
              <div
                key={index}
                className={`w-full md:max-w-[989px] h-[200px] md:h-[556px] mx-auto mb-5`}
              >
                {video.type === UploadedVideoTypes.Custom && video && (
                  <CustomVideo video={video} className="w-full" />
                )}
                {video.type === UploadedVideoTypes.YouTube && (
                  <iframe
                    width="100%"
                    height="100%"
                    src={video.safeUrl}
                    allowFullScreen
                  ></iframe>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default VideoListModal;
